import { DataService } from '../dataService';

export const bookChapterNameService = {
  getNames: async (book_id) => {
    if (!book_id) return;
    try {
      const response = await DataService.get(`/book-chapter-name/${book_id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  toggleExclude: async (data) => {
    try {
      const response = await DataService.post(`/book-chapter-name/exclude/toggle`, data);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
